import PropTypes from 'prop-types';
import React from 'react';

import ReuseContentModule from '@components/Studio/ReuseContentModule';

const PostContentModules = ({ post }) => {
  return (
    <div>
      {post.reuseContentModules.map((obj, index) => {
        return <ReuseContentModule contentModule={obj} key={index} />;
      })}
    </div>
  );
};

PostContentModules.propTypes = {
  post: PropTypes.shape({
    reuseContentModules: PropTypes.array,
  }),
};

export default PostContentModules;
